// extracted by mini-css-extract-plugin
module.exports = {"root":"Size__root___1E8BZ","value":"Size__value___1Vp61","bold":"Size__bold___2jCWX","large":"Size__large___387Lw","separator":"Size__separator___23q8t"};